import {
    TOKEN_STORAGE_KEY,
    ORGANIZATION_STORAGE_KEY,
    COUNTRY_STORAGE_KEY,
    CURRENCY_STORAGE_KEY,
} from '../constants';

const AUTH_SESSION_STORAGE_KEYS = [
    TOKEN_STORAGE_KEY,
    ORGANIZATION_STORAGE_KEY,
    COUNTRY_STORAGE_KEY,
    CURRENCY_STORAGE_KEY,
] as const;

export const clearAuthSessionStorage = () => {
    if (typeof window === 'undefined') return;

    AUTH_SESSION_STORAGE_KEYS.forEach((key) => {
        try {
            window.sessionStorage.removeItem(key);
        } catch {
            /* ignore sessionStorage access issues */
        }
    });
};

export const getAuthToken = () => {
    if (typeof window === 'undefined') return undefined;
    try {
        return window.sessionStorage.getItem(TOKEN_STORAGE_KEY) ?? undefined;
    } catch {
        return undefined;
    }
};

export const setAuthToken = (token: string | null | undefined) => {
    if (typeof window === 'undefined') return;
    if (typeof token !== 'string') return;
    try {
        window.sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    } catch {
        /* ignore sessionStorage access issues */
    }
};
